import { ANDROID_PACKAGE_ID, PLAY_STORE_URL } from './appLinks';

export const INVITE_PATH = '/invite';
export const INVITE_BASE_URL = `https://morafaa.web.app${INVITE_PATH}`;
export const PENDING_INVITE_REF_KEY = 'morafaa_pending_invite_ref';

/** iOS App Store — update when Morafaa iOS is live on the store. */
export const APP_STORE_URL = 'https://apps.apple.com/app/id123456789';

export function buildInviteUrl(ref: string): string {
  const code = ref.trim();
  if (!code) return INVITE_BASE_URL;
  return `${INVITE_BASE_URL}?ref=${encodeURIComponent(code)}`;
}

/**
 * Forwards `ref` to Play Install Referrer (separate from UTM marketing params).
 */
export function buildPlayStoreUrlWithInviteRef(ref: string): string {
  const code = ref.trim();
  if (!code) return PLAY_STORE_URL;
  const referrer = encodeURIComponent(`ref=${code}`);
  return `${PLAY_STORE_URL}&referrer=${referrer}`;
}

export function parseInviteRefFromSearch(search: string): string | null {
  const ref = new URLSearchParams(search).get('ref')?.trim();
  return ref || null;
}

export type InvitePlatform = 'android' | 'ios' | 'desktop';

export function detectInvitePlatform(userAgent: string): InvitePlatform {
  const ua = userAgent.toLowerCase();
  if (/android/i.test(ua)) return 'android';
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
  return 'desktop';
}
